import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="clipboard"
export default class extends Controller {
  static values = {
    content: String
  }

  static targets = ["buttonText"]

  copy() {
    const content = this.contentValue

    navigator.clipboard.writeText(content).then(
      () => {
        this.showSuccess()
      },
      (err) => {
        console.error("Failed to copy:", err)
        this.showError()
      }
    )
  }

  showSuccess() {
    const originalText = this.hasButtonTextTarget ? this.buttonTextTarget.textContent : null

    if (this.hasButtonTextTarget) {
      this.buttonTextTarget.textContent = "Copied!"
    }

    // Add visual feedback
    this.element.classList.add("btn-success")

    // Reset after 2 seconds
    setTimeout(() => {
      if (this.hasButtonTextTarget && originalText) {
        this.buttonTextTarget.textContent = originalText
      }
      this.element.classList.remove("btn-success")
    }, 2000)
  }

  showError() {
    const originalText = this.hasButtonTextTarget ? this.buttonTextTarget.textContent : null

    if (this.hasButtonTextTarget) {
      this.buttonTextTarget.textContent = "Failed"
    }

    // Add visual feedback
    this.element.classList.add("btn-error")

    // Reset after 2 seconds
    setTimeout(() => {
      if (this.hasButtonTextTarget && originalText) {
        this.buttonTextTarget.textContent = originalText
      }
      this.element.classList.remove("btn-error")
    }, 2000)
  }
}
